<template>

  <div>

    <t-page-form-field-customizable
        btn-submit-primary
        v-model="form.fieldCustomizable" :command="command" :status="status"
        :path="path" :primaryKeyColumn="primaryKeyColumn" :foreign-key-column="foreignKeyColumn"
        :primary-key="form.processFlowStepFieldId" :foreign-key="form.processFlowStepId"
        :items="items" :user-auth="userAuth"
        :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
        :error-field="error_fieldCustomizable" :general-errors="generalErrors"
        @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault"
        @onCancelUpdatedList="cancelUpdatedField" @onRequestList="getList">

      <template #form-row-top>

        <b-row>
          <t-input label="Tipo de Preenchimento" v-model="form.fillType" required select-common
                   :options="fillTypeOptions" cols="6" :add-error="error.fillType"/>

          <t-input label="Tag para Fórmulas" v-model="form.calculationTag" only-letters upper
                   help="Utilize para aplicação de fórmulas de cálculo" cols="6" :add-error="error.calculationTag"/>
        </b-row>


      </template>

    </t-page-form-field-customizable>

  </div>


</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin";
import pageFormFieldMixin from "@/mixins/page/pageFormFieldMixin";


import tPageFormFieldCustomizable from "@/components/template/page/t-page-form-field-customizable";

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin, pageFormFieldMixin],
  components: {tPageFormFieldCustomizable},
  name: 'ProcessFlowStepField',
  data() {
    return {
      path: "production/process-flow-step-field", //Utilizar somente quando fora do padrão
      primaryKeyColumn: "processFlowStepFieldId",
      foreignKeyColumn: "processFlowStepId", //Utilizar quando usar Tabs com outros componentes
      form: {
        processFlowStepId: this.foreignKey,
        processFlowStepFieldId: 0,
        fieldCustomizable: {},
        fillType: 1,
        calculationTag: "",
      },
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      fillTypeOptions: [
        {value: "1", text: "Novo valor a cada Ordem Produção"},
        {value: "2", text: "Traz do histórico/processo, operador NÃO edita"},
        {value: "3", text: "Traz do histórico/processo, operador PODERÁ editar"},
      ],
      error: {//Campos que podem receber retorno de erro do backend
        fillType: "",
        calculationTag: "",
      },

      //--------------------------------------------------------------------------------------
    }
  },
  props: {
    typeImage: Boolean,
  },
  methods: {

    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormField()


    },

    mountedPrepare() {

      this.defaultForm()
      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {

      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.processFlowStepFieldId)

    },

    mountedList() {

      // Manipulação da listagem após carregando
      //--------------------------------------

      //--------------------------------------

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
